import {Card} from '/ui/components/card/card';
import ExternalLinkSvg from '/ui/icons/inline/external-link.svg';

import * as Types from '/ui/components/marketingactivationpage/types';

import * as styles from '/ui/components/marketingactivationpage/linkcard.module.scss';


/**
 * @param {!Types.LinkCardContent} props
 */
export function LinkCard({
  type,
  headline,
  href,
}) {
  return (
    <Card
      href={href}
      openLinkInNewWindow
    >
      <div className={styles.cardBody}>
        <div className={styles.topRow}>
          {type}
          {<ExternalLinkSvg/>}
        </div>
        <div className={styles.headline}>
          {headline}
        </div>
      </div>
    </Card>
  );
}
